import script from "./ItemGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemGrid.vue?vue&type=script&setup=true&lang=js"

import "./ItemGrid.vue?vue&type=style&index=0&id=3ac0ec4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac0ec4a"]])

export default __exports__